/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum LoginFromProvider {
  apple = 'apple',
  auth0 = 'auth0',
  email = 'email',
  google = 'google',
  phone = 'phone'
}

/**
 * LoginFromProvider
 *
 * The supported backing login from providers.
 */
export const LoginFromProviderEnumType = types.enumeration('LoginFromProvider', [
  'apple',
  'auth0',
  'email',
  'google',
  'phone'
])
